<template>
  <div
    id="move-veto-control-modal"
    tabindex="-1"
    aria-hidden="true"
    data-modal-backdrop="static"
    class="fixed top-0 left-0 right-0 z-50 items-center justify-center hidden w-full overflow-x-hidden overflow-y-auto md:inset-0 h-modal md:h-full"
  >
    <div class="relative w-full max-w-2xl">
      <!-- Modal content -->
      <div class="relative pt-4 pb-2 bg-gray-200 rounded-lg shadow  flex flex-col items-stretch">
        <!-- Modal header -->
        <div class="px-4 flex items-center justify-between pb-1 mb-2 border-b border-gray-200 rounded-t sm:mb-2 ">
          <h3 class="text-left left font-semibold text-gray-900 text-lg ">
            <h5 class="font-semibold text-gray-900 text-lg ">
              <span class="">Gibier</span> <span class="italic text-gray-700">{{ input.source?.name }} (Bague : {{ input.source?.number }})</span>
            </h5>
          </h3>

          <button
            type="button"
            class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 inline-flex "
            @click="onClose()"
          >
            <svg aria-hidden="true" class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
              <path
                fill-rule="evenodd"
                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                clip-rule="evenodd"
              />
            </svg>
            <span class="sr-only">Close modal</span>
          </button>
        </div>

        <div class="flex items-stretch bg-white rid gap-4 mb-4 sm:grid-cols-1 sm:gap-6 sm:mb-5 p-4">
          <div class="w-full h-full">
            <p class="text-base font-bold text-left text-gray-500  mb-4">Veuillez choisir le nouveau N° de lot pour ce gibier</p>
            <form class="flex items-center mx-2 flex flex-col w-full items-center justify-start">
              <label for="simple-search" class="sr-only">Rechercher</label>
              <div class="relative w-full">
                <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                  <svg class="w-4 h-4 text-gray-500 " aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                  </svg>
                </div>
                <input
                  @keyup="onChange"
                  v-model="query"
                  type="text"
                  id="simple-search"
                  class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full ps-10 p-2.5      "
                  placeholder="Rechercher par numéro, nom du vétérinaire"
                  required
                />
              </div>
            </form>

            <div class="w-full bg-white mx-2 text-left justify-left relative mt-3">
              <div class="flex flex-col w-full pr-2 text-sm font-medium bg-white border border-gray-200 rounded-lg    h-96 overflow-y-auto">
                <button
                  v-for="item in filtered_items"
                  :key="item.id"
                  type="button"
                  @click="onSelect(item)"
                  class="flex flex-row justify-left items-center w-full px-4 py-2 font-medium text-left border-b border-gray-200 cursor-pointer hover:bg-blue-500 hover:text-white focus:outline-none focus:font-bold focus:ring-2 focus:ring-blue-700 focus:text-white focus:bg-blue-700    "
                  :class="{ 'text-white bg-blue-700': selected != undefined && item?.id === selected?.id, 'text-gray-900 bg-white': item?.id != selected?.id }"
                >
                  <div class="left text-left w-36 justify-left truncate">
                    {{ item.done_at }}
                  </div>
                  <div class="left text-left w-64 justify-left truncate px-3">
                    {{ item.name }}
                  </div>

                  <div class="right truncate w-full px-3">
                    {{ item.controller_name }}
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="flex items-center justify-between px-4">
          <div class="text-gray-500 italic text-xs">*721*</div>
          <div class="flex items-center justify-end">
            <button
              type="button"
              class="mr-3 py-2.5 px-5 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-primary-700 focus:z-10 focus:ring-4 focus:ring-gray-200      "
              @click="onClose()"
            >
              Annuler
            </button>
            <button
              type="button"
              class="inline-flex items-center text-white focus:ring-4 focus:outline-none focus:ring-gray-300 font-bold rounded-lg text-sm px-5 py-2.5 text-center  "
              :disabled="selected == undefined"
              :class="{ ' bg-gray-600 hover:bg-gray-700': selected != undefined, ' bg-gray-400 hover:bg-gray-400': selected == undefined }"
              @click="onValidate"
            >
              <span v-if="input?.source?.action == 'add-game-batch-2'">AJOUTER AU LOT</span>

              <span v-if="input?.source?.action == 'move-game-batch-2'">DEPLACER DANS CE LOT</span>

              <span v-if="input?.source?.action != 'add-game-batch-2' && input?.source?.action != 'move-game-batch-2'">DEPLACER {{ input?.source?.action }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import labels from "@/assets/lg/attribut.json";
import service from "@/services/FullService.vue";
import { mapGetters } from "vuex";

export default {
  name: "VetoControlMoveModal",
  props: {
    input: Object,
    refresh: String,
  },
  computed: {
    ...mapGetters({ user: "StateUser" }),
    isLoggedIn: function () {
      return this.$store.getters.isAuthenticated;
    },
  },
  data() {
    return {
      lg: "FR",
      labels: labels,
      price: "",
      mode: "",
      id: null,
      items: [],
      selected: null,
      filtered_items: [],
      query: "",
    };
  },
  watch: {
    refresh: function () {
      this.selected = null;
    },
    input: async function () {
      this.id = this.input?.id;
      this.source = this.input?.source?.source;
      this.loadBatches();
    },
  },
  async mounted() {
    this.id = this.input?.id;
    this.source = this.input?.source?.source;
  },
  methods: {
    onChange() {
      let q = this.query;
      this.filtered_items = this.items.filter(function (a) {
        return a.hunter_number.indexOf(q) != -1 || a.hunter_name.indexOf(q) != -1 || a.name.indexOf(q) != -1;
      });
    },
    displayDate(d) {
      if (d == undefined) return "";
      let s = d.split("T");
      let ss = s[0].split("-");
      return ss[2] + "/" + ss[1] + "/" + ss[0];
    },
    async loadBatches() {
      //let id = "6731b0d47bd980a4783475a9"  //v1
      let id = "675eb8bf631f5e8528e0767c"; //v2
      let records = await service.getData("data-sources/" + id + "/records", this.user?.token, Object.assign({ limit: 5000, offset: 0, entity_id: this.input.entity_id }));
      let items = [];

      for (let i = 0; i < records.records.length; i++) {
        if (this.input.action == "add-game-batch-2" || this.input.source?.record_id.toString() != records.records[i]._id.toString())
          items.push({
            id: records.records[i]._id,
            name: records.records[i].number,
            done_at: this.displayDate(records.records[i].done_at),
            controller_name: records.records[i]?.controller_name,
            hunter_number: "",
          });
      }
      this.items = records.records;
      this.filtered_items = items;
      this.query = "";
    },
    onSelect(id) {
      this.selected = id;
    },
    onValidate() {
    
 
      let item = {
        id: this.input._id,
        action: this.input.action,
        source: {
          id: this.input.source?.record_id,
          record_id: this.input.source?.record_id,
        },
        target: this.selected,
      };
      this.$emit("confirm", item);
    },
    onClose() {
      this.$emit("close");
    },
  },
  components: {},
};
</script>
